import React from "react";
import BlogList from "../components/Blogs/BlogList";
import { PageLayout } from "../components/Layout";

const BlogListPage: React.FC = () => {
  return (
    <PageLayout
      title="Blog"
      subtitle="Sharing insights, tutorials, and thoughts on web development and technology"
    >
      <BlogList />
    </PageLayout>
  );
};

export default BlogListPage;
